import { ADMIN_ROLES, Organization, Permission } from '../models';

export const isAdmin = (permission: Permission): boolean => ADMIN_ROLES.includes(permission);

/** Tier1 organizations and organizations with a non-active license are restricted for non-admins. */
export const isOrganizationRestricted = (organization: Pick<Organization, 'subscriptionPlan' | 'licenseStatus'>): boolean =>
  organization.subscriptionPlan === 'Tier1' || (!!organization.licenseStatus && organization.licenseStatus !== 'ACTIVE');
